/* Marca las tallas que hay en existencia y ajusta la fecha estimada.
   Los datos los emite layout/theme.liquid en el script #stock-rapido,
   porque /products/x.js no expone inventory_quantity.

   16-sep-2026: el stock vive en Guadalajara y sale por Envia.com. Por eso la
   estimacion "rapida" es de 1 a 5 dias habiles (1 a 2 entrega personal en GDL,
   2 a 5 envio al resto del pais). El perfil de envio "Stock en Guadalajara"
   cobra esas tallas aparte en el checkout. */
(function(){
  var datos  = document.getElementById('stock-rapido');
  var tallas = document.querySelector('.producto .tallas');
  if (!datos || !tallas) return;

  var stock = {};
  try {
    JSON.parse(datos.textContent).forEach(function(v){ stock[v.id] = v.n; });
  } catch (e) { return; }

  var hayRapido = false;

  [].slice.call(tallas.querySelectorAll('.tallas__radio')).forEach(function(r){
    var n = stock[r.value] || 0;
    r.dataset.rapido = n > 0 ? '1' : '0';
    if (n > 0 && !r.disabled) {
      hayRapido = true;
      var etiqueta = tallas.querySelector('label[for="' + r.id + '"]');
      if (etiqueta) etiqueta.classList.add('tallas__btn--rapido');
    }
  });

  if (!hayRapido) return;

  var leyenda = document.createElement('p');
  leyenda.className = 'tallas__rapido';
  var unico = datos.dataset.stock === '1';
  leyenda.innerHTML = '<i aria-hidden="true"></i><span>' + (unico
    ? 'Este par ya está en Guadalajara: <b>entrega personal gratis</b> en un lugar público (te escribimos para acordar) o envío por paquetería de 1 a 5 días hábiles.'
    : 'Las tallas marcadas ya las tenemos en Guadalajara: <b>entrega personal gratis en GDL</b> o envío por paquetería de 1 a 5 días hábiles.') + '</span>';
  tallas.insertAdjacentElement('afterend', leyenda);

  var est = document.querySelector('[data-entrega]');
  if (!est) return;

  var lentoMin = parseInt(est.dataset.min, 10) || 12;
  var lentoMax = parseInt(est.dataset.max, 10) || 15;

  function habiles(n){
    var d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function fdia(d){ return d.toLocaleDateString('es-MX', { day: 'numeric', month: 'long' }); }

  function pintar(){
    var elegida = tallas.querySelector('.tallas__radio:checked');
    var rapido  = !!(elegida && elegida.dataset.rapido === '1');
    var min = rapido ? 1 : lentoMin;
    var max = rapido ? 5 : lentoMax;
    est.classList.toggle('entrega-est--rapida', rapido);
    // conserva data-fecha-min/max para no romper el script de la sección
    est.innerHTML = (rapido ? '<b class="entrega-est__flash">En existencia</b> ' : '') +
      '<span>Llegaría entre el <b data-fecha-min>' + fdia(habiles(min)) +
      '</b> y el <b data-fecha-max>' + fdia(habiles(max)) + '</b></span>';
  }

  tallas.addEventListener('change', pintar);
  pintar();
})();
